<div class="promo-countdown">
    <div class="unit">
        <b>{{ days }}</b>
        <span>jour{{ days > 1 ? 's' : '' }}</span>
    </div>
    <div class="unit">
        <b>{{ hours | number:'2.0-0' }}</b>
        <span>heure{{ hours > 1 ? 's' : '' }}</span>
    </div>
    <div class="unit">
        <b>{{ minutes | number:'2.0-0' }}</b>
        <span>minute{{ minutes > 1 ? 's' : '' }}</span>
    </div>
    <div class="unit">
        <b>{{ seconds | number:'2.0-0' }}</b>
        <span>seconde{{ seconds > 1 ? 's' : '' }}</span>
    </div>
</div>
